import { api } from "aldoo-ra/API"

const taxonomyAPI = api("taxonomy")

export const listNodes = (params = {}) => taxonomyAPI({ list_nodes: params })
export const getNode = (slug) => taxonomyAPI({ get_node: { slug } })
export const saveNode = (payload) => taxonomyAPI({ save_node: payload })
export const moveNode = (slugs, parentSlug) => taxonomyAPI({ move_node: { slugs, parentSlug } })
export const addParent = (slugs, parentSlug) => taxonomyAPI({ add_parent: { slugs, parentSlug } })
export const removeParent = (slugs, parentSlug) => taxonomyAPI({ remove_parent: { slugs, parentSlug } })
export const deleteNode = (slug) => taxonomyAPI({ delete_node: { slug } })

export const listDbModels = () => taxonomyAPI({ list_db_models: {} })
export const getClassifiedItem = (dataId, dataType) =>
  taxonomyAPI({ get_classified_item: { dataId, dataType } })
export const listModelItems = (params) => taxonomyAPI({ list_model_items: params })
export const listClassifications = (params) => taxonomyAPI({ list_classifications: params })
export const assignClassification = (dataIds, dataType, taxonomySlug) =>
  taxonomyAPI({ assign_classification: { dataIds, dataType, taxonomySlug } })
export const removeClassification = (params) => taxonomyAPI({ remove_classification: params })
export const getClassifiedIds = (dataType, taxonomySlug) =>
  taxonomyAPI({ get_classified_ids: { dataType, taxonomySlug } })

export const updateClassification = (id, enabled) =>
  taxonomyAPI({ update_classification: { id, enabled } })

export default taxonomyAPI
